import NewsletterFormExt from '_core_ext/components/forms/NewsletterForm';

export default class NewsletterForm extends NewsletterFormExt {
    init() {
        super.init();

        this.event('change', '.showStatusIcon', this.showStatusIcon);
        this.event('change', '.js-notifyme-acceptlettersubscription', this.acceptNewsletter);
    }

    showStatusIcon(el, event) {
        $(event.target).siblings('.success-icon, .error-icon').hide();
        if (!$(event.target).valid()) {
            $(event.target).siblings('.error-icon').show();
        } else {
            $(event.target).siblings('.success-icon').show();
        }
    }
    acceptNewsletter(el, event) {

        if ($('.js-notifyme-acceptlettersubscription').is(':checked')) {
            //console.log("Checked");
        }else{
            //cosnole.log("unchecked");
        }
        
    }

    onSubmitSuccess(result) {
        this.$el.trigger('newsletterSubscription.success', [this.$el]);
        $('#header-top-banner, #header-bottom-banner, .js-header-nav-container, .header__menu-utility, .js-menu-tab-content').removeClass('d-none');
        $('#logo').removeClass('logo-space');
        this.$el.find('.js-emailform-wrapper').hide();
        this.$el.find('.redbull-form').hide();
        this.$el.find('.js-toggle_content').hide();
        this.$el.find('.js-result_message').fadeIn();
        this.$el.find('.js-result_message').parents('.c-account__content').addClass('user-subscribed');
        this.$el.get(0).reset();
    }
}